<template>
  <ul
    id="content-list"
    class="page-list p-0 mx-5 mb-5">
    <!-- Content Groups -->
    <li
      v-for="(content, contentGroup) in contentGrouped"
      :key="contentGroup">
      <header class="section-header">{{contentGroup | startCase}}</header>

      <!-- Content For Group -->
      <ul class="p-0">
        <li
          class="page-list-item"
          v-for="c in content"
          :key="c.contentId"
          @click="editContent(c.contentId)">
          <div
            class="d-flex align-stretch">
            <!-- Content ID -->
            <div class="content-id">
              {{contentItemInfo(c.contentId).element}}
              <span
                v-if="contentItemInfo(c.contentId).dimensions.width">
                {{contentItemInfo(c.contentId).dimensions.width}}w
              </span>
              <span
                v-if="contentItemInfo(c.contentId).dimensions.width
                  && contentItemInfo(c.contentId).dimensions.height">
                x
              </span>
              <span
                v-if="contentItemInfo(c.contentId).dimensions.height">
                {{contentItemInfo(c.contentId).dimensions.height}}h
              </span>
            </div>
            <!-- / Content ID -->

            <!-- Color Content -->
            <div
              v-if= "contentItemInfo(c.contentId).section === 'Colors'"
              class="content-content content-color">
              <div
                :style="{
                  backgroundColor: c.content,
                }">
              </div>
            </div>
            <!-- / Color Content -->

            <!-- Non-Color Content -->
            <div
              v-else
              class="content-content">
              <!-- Text / Rich Text -->
              <div
                v-if="c.type === 'text' || c.type === 'richText'">
                <div
                  v-if="c.content"
                  v-html="c.content">
                </div>
                <small
                  v-else
                  class="font-italic text--secondary">
                  not defined
                </small>
              </div>
              <!-- / Text / Rich Text -->

              <!-- Image -->
              <div
                v-else-if="c.type === 'image'">
                <img
                  v-if="c.content"
                  :src="c.content"
                />
                <small
                  v-else
                  class="font-italic text--secondary">
                  not defined
                </small>
              </div>
              <!-- / Image -->
            </div>
            <!-- / Content Contents -->
          </div>
          <v-divider></v-divider>
        </li>
      </ul>
      <!-- / Content For Group -->
    </li>
    <!-- / Content Groups -->
  </ul>
</template>

<script>
import ContentItemMixin from '../mixin.content-item';

export default {
  name: 'ContentList',
  props: ['contentGrouped'],
  mixins: [
    ContentItemMixin,
  ],
  methods: {
    editContent(contentId) {
      this.$store.commit('setContentItemById', contentId);
      this.$router.push({ name: 'ContentEdit', params: { contentId, tab: 'edit' } });
    },
  },
};
</script>

<style lang="scss">
#content-list {
  .page-list-item {
    .content-id {
      width: 20%;
      padding: 7px 14px;
    }

    .content-content {
      width: 80%;
      padding: 7px 14px;
      overflow: hidden;
    }
  }
}
</style>
